import svgPaths from "./svgPath";
import { useEffect, useState } from "react";
import ZeroBased from '../../Assets/Blog/zero-img.png'
import imgEllipse1 from "../../Assets/Blog/2dc8098d25dec2dac724f9f4d0a649f1d6a3a3e3.png";
import imgHeroImage from "../../Assets/Blog/0261fe84790a6aa1ae941759a6c59e1bc8223591.png";

function StateLayer() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px 18px",
      }}
    >
      <p
        style={{
          color: "#1d1b20",
          fontSize: "16px",
          fontWeight: 700,
          whiteSpace: "nowrap",
          margin: 0,
          fontFamily: "Quicksand, sans-serif",
        }}
      >
        Zero Budgeting
      </p>
    </div>
  );
}

function HeaderImages() {
  return (
    <div
      style={{
        position: "relative",
        width: "42%",
    
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius:9999
      }}
    >
      {/* Ellipse Background */}
  

      {/* Hero Image */}
      <img
        src={ZeroBased}
        alt="Financial Planning"
        style={{
          width: "84%",
          
          
          position: "relative",
          zIndex: 2,
        }}
      />
    </div>
  );
}

function BlogHeroWave() {
  const [isMobile, setIsMobile] = useState(
  window.innerWidth <= 768
);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);

  return () => {
    window.removeEventListener(
      "resize",
      handleResize
    );
  };
}, []);

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        background: "#b39ddb",
        minHeight: isMobile ? "auto" : "320px",
      }}
    >
      {/* Background SVG */}
      <div
        style={{
          position: "absolute",
          inset: 0,
        }}
      >
        <svg
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
          }}
          fill="none"
          preserveAspectRatio="none"
          viewBox="0 0 1753 459"
        >
          <path d={svgPaths.p5117980} fill="#CCC8EA" />
        </svg>
      </div>

      {/* Main Content */}
      <div
        style={{
          position: "relative",
          
         
          margin: "0 auto",
          padding: isMobile ? "32px 20px" : "50px 180px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "32px",
        }}
      >
        {/* Left Content */}
        <div
          style={{
            width: isMobile ? "100%" : "100%",
          }}
        >
          {/* Chip */}
          <div
            style={{
              display: "inline-flex",
              background: "#fff",
              borderRadius: "10px",
              border: "1px solid #6750a4",
              marginBottom: "24px",
            }}
          >
            <StateLayer />
          </div>

          {/* Heading */}
          <h1
            style={{
              color: "#000",
              fontWeight: 700,
           
              fontSize: isMobile
                ? "2.2rem"
                : "48px",
              lineHeight: isMobile ? "1.1" : "1.08",
               fontFamily: "Quicksand",
              margin: 0,
            }}
          >
            Zero-Based Budgeting:
          
            The Complete 2026 Guide
          </h1>

          {/* Subtitle */}
          <p
            style={{
              color: "#000",
              fontStyle: "italic",
              marginTop: "20px",
              maxWidth: isMobile ? "100%" : "100%",
              fontSize: isMobile
                ? "1rem"
                : "clamp(1.2rem, 2vw, 2.2rem)",
              lineHeight: "1.6",
              fontFamily: "Quicksand",
              marginBottom: 0,
            }}
          >
            How to Give Every Dollar a Job  With a Real Step-by-Step Example
          </p>
        </div>

        {/* Hide image on mobile */}
       
      </div>
    </div>
  );
}

export default function Header() {
  return (
    <div style={{ width: "100%" }}>
      <BlogHeroWave />
    </div>
  );
}